import { AxiosRequestConfig, AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import {
	DomainBySystemApplicationRequest,
	TemplateEmailNotificationDetailRequest,
	TemplateEmailNotificationUpdateRequest,
} from "@/main/models/request/templateEmailNotificationRequest";
import { TemplateEmailNotificationDetailResultResponse } from "@/main/models/response/templateEmailNotificationResponse";

export abstract class ITemplateEmailNotificationApi {
	abstract getDomainBySystemApplication(
		request: DomainBySystemApplicationRequest,
	): Promise<AxiosResponse<Result<KeyValue[]>>>;
	abstract getDetail(
		request: TemplateEmailNotificationDetailRequest,
	): Promise<AxiosResponse<Result<TemplateEmailNotificationDetailResultResponse>>>;
	abstract update(
		request: TemplateEmailNotificationUpdateRequest,
		config?: AxiosRequestConfig,
	): Promise<AxiosResponse<Result<void>>>;
}
